<form [formGroup]="form" class="column-12 form-block">
  <div class="column-6 form-block__input">
    <input formControlName="name"
           id="name"
           type="text"
           class="form-input"
           placeholder="¿Cómo te llamas? *">
    <div *ngIf="form.get('name').errors && form.get('name').dirty">
      <div *ngIf="form.get('name').hasError('required')"
           class="form-input__error nameFail">
        ¡Campo obligatorio!
      </div>
    </div>
  </div>
  <div class="column-6 form-block__input">
    <input formControlName="email"
           id="email"
           type="email"
           class="form-input"
           placeholder="Tu email *">
    <div *ngIf="form.get('email').errors && form.get('email').dirty">
      <div *ngIf="form.get('email').hasError('required')"
           class="form-input__error emailFail">
        ¡Campo obligatorio!
      </div>
      <div *ngIf="form.get('email').hasError('email')"
           class="form-input__error emailFail">
        ¡Formato no válido!
      </div>
    </div>
  </div>
  <div class="column-6 form-block__input">
    <input formControlName="phone"
           id="phone"
           type="text"
           class="form-input"
           placeholder="Un teléfono de contacto">
    <div *ngIf="form.get('phone').errors && form.get('phone').dirty">
      <div *ngIf="form.get('phone').hasError('maxLength')"
           class="form-input__error phoneFail">
        ¡Formato no válido!
      </div>
      <div *ngIf="form.get('phone').hasError('minLength')"
           class="form-input__error phoneFail">
        ¡Formato no válido!
      </div>
      <div *ngIf="form.get('phone').hasError('pattern')"
           class="form-input__error phoneFail">
        ¡Formato no válido!
      </div>
    </div>
  </div>
  <div class="column-6 form-block__input">
    <input formControlName="enterprise"
           id="enterprise"
           type="text"
           class="form-input"
           [placeholder]="resultBase">
    <div *ngIf="form.get('enterprise').errors && form.get('enterprise').dirty">
      <div *ngIf="form.get('enterprise').hasError('required')"
           class="form-input__error enterpriseFail">
        ¡Campo obligatorio!
      </div>
    </div>
  </div>
  <div class="column-12 form-block__input form-block__input--textarea">
				<textarea formControlName="msg"
                  id="msg"
                  class="form-input"
                  placeholder="Cuéntanos un poco más"
                  rows="1"></textarea>
    <div *ngIf="form.get('msg').errors && form.get('msg').dirty">
      <div *ngIf="form.get('msg').hasError('required')"
           class="form-input__error msgFail">
        ¡Campo obligatorio!
      </div>
    </div>
  </div>
  <div class="form-block__checkbox">
    <div class="form-block">
      <label class="form-input__checkbox">
        <input formControlName="checkbox"
               name="checkbox"
               type="checkbox"
               class="form-input">
        <span class="form-input__checkmark"></span>
      </label>
      <label class="form-check-label">
        Acepto las
        <a class="link"
           routerLink="/aviso-legal" target="_blank">
          Condiciones de uso
        </a>
        y
        <a class="link"
           routerLink="/politica-proteccion-datos" target="_blank">Protección
          de datos</a>
      </label>
    </div>
  </div>
  <div *ngIf="form.get('checkbox').value !== true && form.get('checkbox').dirty" class="form-input__error checkFail">
    ¡Campo obligatorio!
  </div>
  <div class="form-block__message">
    <p *ngIf="send === 1">El mensaje se ha enviado correctamente</p>
    <p *ngIf="send === 2">¡Error! El mensaje no ha podido enviarse, pruébelo de nuevo.</p>
  </div>
  <div class="form-block__button">
    <button type="button" class="btn contact-off"
            (click)="sendData()"
            [disabled]="form.invalid || form.get('checkbox').value === false">
      Enviar mensaje
    </button>
  </div>

</form>
